/** Lowercase trimmed query, or empty string when no filter. */
export function normalizeSearch(q) {
  return String(q ?? '').trim().toLowerCase();
}

/** True if concatenation of parts contains the needle (case-insensitive). */
export function textHaystackIncludes(parts, needle) {
  const n = normalizeSearch(needle);
  if (!n) return true;
  const hay = parts.map((p) => String(p ?? '')).join(' ').toLowerCase();
  return hay.includes(n);
}

/** Quote / order-style line rows (read-only or editor). */
export function quoteOrOrderLineMatch(it, needle) {
  return textHaystackIncludes(
    [
      it.itemName,
      it.item?.name,
      it.materialMaster?.name,
      it.itemDetails,
      it.lineDescription,
      it.section,
      it.space,
      it.category,
      it.uom,
      it.remarks,
      it.materialMaster?.description,
    ],
    needle
  );
}

/** Invoice editor / expanded invoice rows. */
export function invoiceLineMatch(it, needle) {
  return textHaystackIncludes(
    [it.itemName, it.itemDetails, it.section, it.remarks, it.uom],
    needle
  );
}

/** Quotes list row (header card). */
export function quoteCardMatch(q, needle) {
  return textHaystackIncludes(
    [
      q.title,
      q.quoteCode,
      q.status,
      q.bhkType,
      String(q._id || ''),
      q.client?.name,
    ],
    needle
  );
}

/** Per-column filters for quote/order-style line rows (empty string = no filter). */
export function matchesItemSpaceMaterialLine(it, f) {
  const fi = normalizeSearch(f?.item ?? '');
  const fs = normalizeSearch(f?.space ?? '');
  const fm = normalizeSearch(f?.material ?? '');
  if (!fi && !fs && !fm) return true;
  if (fi) {
    const blob = `${it.itemName ?? ''} ${it.itemDetails ?? ''} ${it.lineDescription ?? ''}`.toLowerCase();
    if (!blob.includes(fi)) return false;
  }
  if (fs) {
    const sp = String(it.space ?? it.section ?? '').toLowerCase();
    if (!sp.includes(fs)) return false;
  }
  if (fm) {
    const m = String(it.category ?? '').toLowerCase();
    if (!m.includes(fm)) return false;
  }
  return true;
}

/** Invoice / PI line rows: item text + optional section. */
export function matchesItemSectionLine(it, f) {
  const fi = normalizeSearch(f?.item ?? '');
  const fs = normalizeSearch(f?.space ?? '');
  if (!fi && !fs) return true;
  if (fi) {
    const blob = `${it.itemName ?? ''} ${it.itemDetails ?? ''}`.toLowerCase();
    if (!blob.includes(fi)) return false;
  }
  if (fs) {
    const sp = String(it.section ?? '').toLowerCase();
    if (!sp.includes(fs)) return false;
  }
  return true;
}

/** Order line list (item name + description; optional section / UOM). */
export function matchesOrderLine(it, f) {
  const fi = normalizeSearch(f?.item ?? '');
  const fs = normalizeSearch(f?.section ?? '');
  const fu = normalizeSearch(f?.uom ?? '');
  if (!fi && !fs && !fu) return true;
  if (fi) {
    const blob = `${it.itemName ?? ''} ${it.item?.name ?? ''} ${it.materialMaster?.name ?? ''} ${it.lineDescription ?? ''} ${it.materialMaster?.description ?? ''}`.toLowerCase();
    if (!blob.includes(fi)) return false;
  }
  if (fs) {
    const sp = String(it.section ?? '').toLowerCase();
    if (!sp.includes(fs)) return false;
  }
  if (fu && !String(it.uom ?? '').toLowerCase().includes(fu)) return false;
  return true;
}

/** Invoice lines (editor table or expanded read-only): per-field filters; empty fields ignored. */
export function matchesInvoiceEditorLine(it, f) {
  const fi = normalizeSearch(f?.item ?? '');
  const fs = normalizeSearch(f?.section ?? '');
  const fr = normalizeSearch(f?.remarks ?? '');
  const fu = normalizeSearch(f?.uom ?? '');
  const fc = normalizeSearch(f?.category ?? '');
  if (!fi && !fs && !fr && !fu && !fc) return true;
  if (fi) {
    const blob = `${it.itemName ?? ''} ${it.itemDetails ?? ''}`.toLowerCase();
    if (!blob.includes(fi)) return false;
  }
  if (fs && !String(it.section ?? '').toLowerCase().includes(fs)) return false;
  if (fr && !String(it.remarks ?? '').toLowerCase().includes(fr)) return false;
  if (fu && !String(it.uom ?? '').toLowerCase().includes(fu)) return false;
  if (fc && !String(it.category ?? '').toLowerCase().includes(fc)) return false;
  return true;
}

